import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, tokenStore, formatApiError } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { tr } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      tokenStore.set(data.access_token);
      toast.success("Welcome");
      nav("/admin");
    } catch (e2) {
      const msg = formatApiError(e2?.response?.data?.detail) || e2.message;
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] grain px-6" data-testid="page-admin-login">
      <form
        onSubmit={submit}
        className="w-full max-w-sm border border-[#1A1A1A] bg-[#FDFBF7] p-10"
        data-testid="admin-login-form"
      >
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#8C7A6B] mb-4">Lama</div>
        <h1 className="font-serif text-3xl font-light text-[#1A1A1A] mb-10">{tr("admin.loginTitle")}</h1>

        <div className="space-y-6">
          <div>
            <Label className="text-[11px] uppercase tracking-[0.25em] text-[#8C7A6B]">{tr("admin.email")}</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              className="mt-2 bg-transparent border-0 border-b border-[#E5E0D8] rounded-none focus-visible:ring-0 focus-visible:border-[#1A1A1A] px-0"
            />
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-[0.25em] text-[#8C7A6B]">{tr("admin.password")}</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="mt-2 bg-transparent border-0 border-b border-[#E5E0D8] rounded-none focus-visible:ring-0 focus-visible:border-[#1A1A1A] px-0"
            />
          </div>
          {err && <div className="text-sm text-red-700" data-testid="admin-login-error">{err}</div>}
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1A1A1A] text-[#FDFBF7] hover:bg-black rounded-none py-6 text-[11px] uppercase tracking-[0.3em]"
            data-testid="admin-login-submit"
          >
            {loading ? "..." : tr("admin.login")}
          </Button>
        </div>
      </form>
    </div>
  );
}
